// Generated by ts-to-zod
import { z } from 'zod'

export const featureFlagsSchema = z.record(z.union([z.boolean(), z.string()]))
